var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_236_25747"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.75,
    y: -0.75,
    width: 41.5,
    height: 41.5,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_236_25747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.173912999999999,32L8,32L8,36.173913L12.173912999999999,36.173913L12.173912999999999,34.8369141L28.119522,34.8369141L28.119522,43.64648L10.3254724,43.64648L10.3254724,54.663L27.826172,54.663L27.826172,56.000084L32.000084,56.000084L32.000084,51.826172L27.826172,51.826172L27.826172,53.163L11.8254724,53.163L11.8254724,45.14648L29.619522,45.14648L29.619522,33.3369141L12.173912999999999,33.3369141L12.173912999999999,32Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1,
    transform: "matrix(0,-1,1,0,-24,40)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon);
export default __webpack_public_path__ + "static/media/line-icon.3326fcd141719083cd307f8aebdbe3b9.svg";
export { ForwardRef as ReactComponent };